// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"RealStories_TheComp__A8me2"};